<template>
  <Band container="xs">
    <Icon
      icon="cookie-bite"
      prefix="far"
      class="text-4xl text-[#ea9654]"
    />
    <ContentRenderer
      v-if="data"
      :value="data"
      :data="mdcVars"
      class="prose mt-3"
    />
  </Band>
</template>

<script setup lang="ts">
const { data } = await useAsyncData(() => queryCollection('content').path('/cookies').first())

const mdcVars = ref({
  title: 'Cookies',
  description: 'This page explains our use of cookies. We value your privacy and only use third-party services and cookies that respect it.',
  updatedAt: '30th January 2025'
})

useSeoMeta({
  title: mdcVars.value.title,
  description: mdcVars.value.description
})
</script>
